import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas"]

  connect() {
    this.setupCanvas()
    this.startAnimation()
  }

  disconnect() {
    this.stopAnimation()
  }

  setupCanvas() {
    this.canvas = this.canvasTarget
    this.ctx = this.canvas.getContext('2d')

    // 设置canvas尺寸
    this.resizeCanvas()
    window.addEventListener('resize', () => this.resizeCanvas())

    // Matrix字符集 - 使用数字、字母和一些中文字符
    this.chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ代码软件开发AI智能数字化ありがとう'.split('')
    this.fontSize = 12
    this.columns = this.canvas.width / this.fontSize

    // 初始化雨滴位置 - 在整个画布高度范围内随机分布
    this.drops = []
    const maxRows = this.canvas.height / this.fontSize
    for (let i = 0; i < this.columns; i++) {
      this.drops[i] = Math.floor(Math.random() * maxRows)
    }
  }

  resizeCanvas() {
    const parent = this.canvas.parentElement
    this.canvas.width = parent.offsetWidth
    this.canvas.height = parent.offsetHeight
  }

  startAnimation() {
    this.animationFrame = setInterval(() => this.draw(), 180)
  }

  stopAnimation() {
    if (this.animationFrame) {
      clearInterval(this.animationFrame)
    }
  }

  draw() {
    // 使用透明度很低的清除，让渐变背景保持可见
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    // 设置字符颜色和字体
    this.ctx.font = `${this.fontSize}px monospace`

    // 绘制字符，使用渐变透明度产生拖尾效果
    for (let i = 0; i < this.drops.length; i++) {
      // 随机选择字符
      const char = this.chars[Math.floor(Math.random() * this.chars.length)]
      const x = i * this.fontSize
      const y = this.drops[i] * this.fontSize

      // 绘制多个字符产生拖尾效果
      for (let j = 0; j < 5; j++) {
        const trailY = y - (j * this.fontSize)
        if (trailY > 0) {
          const opacity = 1 - (j * 0.4) // 逐渐变透明
          this.ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`
          this.ctx.fillText(char, x, trailY)
        }
      }

      // 随机重置雨滴
      if (y > this.canvas.height && Math.random() > 0.975) {
        this.drops[i] = 0
      }

      // 增加Y坐标
      this.drops[i]++
    }
  }
}
